import { ArrowBack, SearchOff } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";


export function QuotesNoResults() {
    let navigate = useNavigate();

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="60vh"
            textAlign="center"
        >
            <SearchOff sx={{ fontSize: 60, color: "text.secondary", mb: 2 }} />
            <Typography variant="h6" gutterBottom>
                No results found
            </Typography>
            <Typography variant="body2" color="text.secondary">
                Try adjusting your search or filters to find what you're looking for.
            </Typography>
            <Button
                variant="contained"
                startIcon={<ArrowBack />}
                onClick={() => navigate(-1)}
            >
                Go Back
            </Button>
        </Box>
    );
}